import React from 'react';
import { ShieldCheck, PencilRuler, Award, Users } from 'lucide-react';
import { COLORS, TYPOGRAPHY } from './design-tokens';

const Footer = () => {
  const items = [
    { icon: ShieldCheck, line1: 'SEGURANÇA', line2: 'E CONFIANÇA' },
    { icon: PencilRuler, line1: 'PROJETOS', line2: 'PERSONALIZADOS' },
    { icon: Award, line1: 'QUALIDADE', line2: 'EM CADA DETALHE' },
    { icon: Users, line1: 'ATENDIMENTO', line2: 'ESPECIALIZADO' }
  ];

  return (
    <div
      style={{
        background: COLORS.primary,
        color: COLORS.card,
        padding: '10px 16px',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        alignItems: 'center',
        marginTop: '6mm'
      }}
    >
      {items.map((item, i) => (
        <React.Fragment key={i}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <item.icon size={20} color={COLORS.card} strokeWidth={2} />
            <div>
              <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1px' }}>
                {item.line1}
              </div>
              <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1px' }}>
                {item.line2}
              </div>
            </div>
          </div>
          {i < items.length - 1 && (
            <div
              style={{
                width: '1px',
                height: '24px',
                background: COLORS.card,
                opacity: 0.4,
                justifySelf: 'center'
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Footer;
